export const HOME_LOAD = 'home/on_load';
export const homeLoad = () => ({
  type: HOME_LOAD
});

export const HOME_LOAD_SUCCESS = 'home/on_load_success';
export const homeLoadSuccess = () => ({
  type: HOME_LOAD_SUCCESS
});